<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Approval Barang Hilang</h5>
            </template>
            <DetailGadaiKomp :detailGadai="dataBarangHilang.detail.gadai" />
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">KETERANGAN</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan Pengajuan</b-col>
                    <b-col v-if="dataBarangHilang.detail.keteranganPengajuan != null">{{ dataBarangHilang.detail.keteranganPengajuan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Eksekutor 1</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks1 != null">{{ dataBarangHilang.detail.eks1 }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses Eksekutor 1 pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataBarangHilang.detail.eks1ProcessedAt )}} {{ $helper.changeDateFormatGetHour(dataBarangHilang.detail.eks1ProcessedAt )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan Eksekutor 1</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks1Keterangan != null">{{ dataBarangHilang.detail.eks1Keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Eksekutor 2</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks2 != null">{{ dataBarangHilang.detail.eks2 }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diproses Eksekutor 2 pada</b-col>
                    <b-col>{{ $helper.changeDateFormat(dataBarangHilang.detail.eks2ProcessedAt )}} {{ $helper.changeDateFormatGetHour(dataBarangHilang.detail.eks2ProcessedAt )}}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan Eksekutor 2</b-col>
                    <b-col v-if="dataBarangHilang.detail.eks2Keterangan != null">{{ dataBarangHilang.detail.eks2Keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Foto Pendukung</b-col>
                    <b-col>
                        <a v-bind:href="$baseFilePath+dataBarangHilang.detail.foto" target="_blank">
                            <img width="150px" :src="$baseFilePath+dataBarangHilang.detail.foto" alt="Foto Pendukung">
                        </a>
                        <span class="file-name mt-2"></span>
                    </b-col>
                </b-row>
            </div>
            <div class="form-content-wrapper mb-4" v-if="allowedProcess != 0">
                <h6 class="form-title">PROSES BARANG HILANG</h6>
                <b-row>
                    <b-col lg="4" md="6">
                        <b-form-group label="Keterangan">
                            <b-form-textarea v-model="input.keterangan" name="keterangan"></b-form-textarea>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="cetak-sbg-btn">
                    <b-row class="ml-0 mt-2">
                        <b-button class="mr-2" variant="pgiBtn" @click="confirmApprove()">Setujui</b-button>
                        <b-button variant="danger" @click="confirmReject()">Tolak</b-button>
                    </b-row>
                </div>
            </div>
        </b-card>
        <ModalConfirm id="modal-approve-nota" title="Confirm Setujui Nota Barang Hilang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menyetujui nota barang hilang ini?" @submit="onProcess(1)" />
        <ModalConfirm id="modal-reject-nota" title="Confirm Tolak Nota Barang Hilang" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menolak nota barang hilang ini?" @submit="onProcess(2)" />
    </div>
</template>

<script>

import DetailGadaiKomp from '../../../components/gadai/DetailGadaiKomp'

export default {
    name: 'detail-barang-hilang',
    components: {
        DetailGadaiKomp
    },
    data(){
        return{
            id: null,
            initStatus: 0,
            isSubmitting: false,
            dataBarangHilang: {
                detail:{
                    gadai: {}
                }
            },
            input:{
                keterangan: ""
            },
            allowedProcess: null
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleBarangHilang = this.$axios.get(`gadai-hilang/daftar-hilang-eksekutor/${this.id}`).then(response => {
                console.log(response.data)
                this.dataBarangHilang = response.data
                
            })

            let getAllowedProcess = this.$axios.get(`gadai-hilang/proses-allowed/${this.id}`).then(response => {
                this.allowedProcess = response.data.id
                console.log(response.data)
            })

            Promise.all([getSingleBarangHilang, getAllowedProcess]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },
        
        //----------------- Submit Process Eksekutor -----------------

        onProcess(id){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("id", this.id)
            if (this.input.keterangan != "") payload.append("keterangan", this.input.keterangan)
            if(id == 1){
                payload.append("approve", true)
            }else{
                payload.append("approve", false)
            }

            this.$axios.post(`gadai-hilang/process-eksekutor-${this.allowedProcess}`, payload).then(response => {
                if(id == 1){
                    this.$helper.setFlash(`Nota Barang Hilang berhasil disetujui!`)
                }else{
                    this.$helper.setFlash(`Nota Barang Hilang berhasil ditolak!`)
                }
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        confirmApprove(){
            this.$bvModal.show("modal-approve-nota")
        },

        confirmReject(){
            if (this.input.keterangan == "") {
                this.$helper.toastErr(this, "Mohon masukkan keterangan di dalam kotak Keterangan!")
            } else {
                this.$bvModal.show("modal-reject-nota")
            }
        },

    },

    created(){
        this.init()
    }
}
</script>
